import React from 'react'
import { LoungeBrandingScreen } from '@/screens/lounges/LoungeBrandingScreen'

export default function LoungeBrandingRoute() {
  return <LoungeBrandingScreen />
}
